<template>
  <SocialBase
    :url="url"
    :fb-text="`${video.title} - ${video.social.facebook}`"
    :tw-text="`${video.title} - ${video.social.twitter}`"
  />
</template>

<script>
import { mapState } from 'vuex'
import SocialBase from '@/components/SocialBase'

export default {
  components: {
    SocialBase,
  },

  data() {
    return {
      url: `${process.env.VUE_APP_MEDIA_URL}${this.$route.path}`,
    }
  },

  computed: {
    ...mapState('videos', ['video']),
  },
}
</script>
